<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";
import { todoComputed, todoMethods} from "@/state/helpers";
import { Helper } from "@/mixin/helper";
import { mapGetters } from 'vuex'

export default {
  page: {
    title: 'Lokasi Teknisi',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },

  computed: {
    ...todoComputed,
    title() {
      return 'Lokasi Teknisi'
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
  },
  mixins: [Helper],
  methods: {
    ...todoMethods,
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-home"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{ 'Lokasi Teknisi' }}</span>
            </template>
            <b-row class="mc-card__list">
              <b-col v-if="this.getAccessFunc('location') || hasAccess('sms-wo-tracking:read')"  md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Technician Location' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_map"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ 'Lokasi Pengerjaan WO' }}</h4>
                    <p>{{ $t('workOrder.subColumn.location') }}</p>
                  </div>
                </b-button>
              </b-col>

              <!-- <b-col v-if="true" md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Technician Plan Route' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_clock"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ 'Rute Planning' }}</h4>
                    <p>{{ 'Cek rute teknisi berdasarkan alamat WO yang akan dikerjakan' }}</p>
                  </div>
                </b-button>
              </b-col> -->
              <b-col v-if="hasAccess('sms-technician-address:read')" md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Technician Address' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_pin"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ 'Alamat Teknisi' }}</h4>
                    <p>{{ 'Menambahkan alamat teknisi saat ini' }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Nearest Technician' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_search"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ 'Teknisi Terdekat' }}</h4>
                    <p>{{ 'Mencari teknisi terdekat berdasarkan cover area teknisi' }}</p>
                  </div>
                </b-button>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
